<!--
 * @Description: 个别教育记录 修改
 * @Author: ztw
 * @Date: 2023-03-01 15:13:39.345
 * @LastEditors: Xyyyyyy
 * @LastEditTime: 2023-11-28 17:56:21
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openEdit" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">修改</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openEdit', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="学期" prop="xqid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.xqid" clearable filterable >
                <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="选择学生" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-button class="mr10" type="primary" @click="openDanTiao=true">选择</el-button>
              <el-tag class="mr10 mt10" v-if="ruleForm.xsid" closable @close="CourseClose">{{ruleForm.xm}}</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="日期" prop="rq" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-date-picker v-model="ruleForm.rq" type="date" value-format="YYYY-MM-DD" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="教育情况" prop="jyqk" >
              <el-input v-model="ruleForm.jyqk" type="textarea" resize="none"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="效果" prop="xg" >
              <el-input v-model="ruleForm.xg" type="textarea" resize="none"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openEdit', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <xueshengdantiao v-if="openDanTiao" v-model:openDanTiao="openDanTiao" :row="row" @ReturnData="ReturnData" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch, unref } from 'vue'
import { submitEditForm, closeWindow, loadData, loadSelect } from '@/api/common.js'
import xueshengdantiao from '@/components/chazhaodaihui/xueshengdantiao.vue'

const props = defineProps({
  openEdit: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openEdit', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const xqData = ref([]) // 学期
watch(
  () => props.openEdit,
  () => {
    if (props.openEdit) {
      loadSelect({
        url: '/api/v2/pdp/xueqi/list',
        data: xqData,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          res.data.forEach((element) => {
            if (element.sfdqxq === true) {
              ruleForm.value.xqid = element.id
            }
          })
        }
      })
      loadData({
        url: '/api/v2/xuesheng/banzhurengongzuogebiejiaoyujilu/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)

// 学生单条
const openDanTiao = ref(false)
const ReturnData = (data) => {
  ruleForm.value.xsid = data.id
  ruleForm.value.xm = data.xm
}
const CourseClose = () => {
  ruleForm.value.xsid = ''
  ruleForm.value.xm = ''
}

// 提交
const submit = async () => {
  submitEditForm({
    url: '/api/v2/xuesheng/banzhurengongzuogebiejiaoyujilu',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openEdit', emits, true)
    }
  })
}
</script>
